






























































































import '../../styles/add-alert-modal.css'
import Vue from 'vue'
import { CIcon } from '@coreui/icons-vue'
import { cilCamera, cilX } from '@coreui/icons-pro'
import ImagePicker from '../general/ImagePicker.vue'
import { validationMixin } from 'vuelidate'
import { required, integer, minValue } from 'vuelidate/lib/validators'

import Modal from '../general/modal/Modal.vue'
import ModalBody from '../general/modal/ModalBody.vue'
import { IValidationResult } from '../../util/IValidationResult'
import DatePicker from '../DatePicker.vue'
import IAlert from '../../viewModel/IAlert'
import { Alerts } from '@/dataLayer/Alerts'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import QuillEditor from '../controls/QuillEditor.vue'

interface IModel {
  cameraIcon: any[]
  exitIcon: any[]
  errors: string[]
  title: string
  content: string
  startDisplayingOn: string
  stopDisplayingOn: string
  addToCalendar: boolean
  startDate: string
  endDate: string
  durationInDays: number
  tags: { value: number; title: string }[]
  saving: boolean
  displayOnCalendar: boolean
  file: File | undefined
}

export default Vue.extend({
  mixins: [validationMixin],
  validations: {
    title: { required },
    content: { required },
    durationInDays: { required, integer, minValue: minValue(1) },
  },
  data: (): IModel => {
    const curDate = new Date()
    const curDateStr = curDate.toISOString().substring(0, 10) // YYYY-MM-DD (required by v-date-picker)

    return {
      cameraIcon: cilCamera,
      exitIcon: cilX,
      errors: [],
      title: '',
      content: '',
      startDisplayingOn: curDateStr,
      stopDisplayingOn: curDateStr,
      startDate: curDateStr,
      endDate: curDateStr,
      addToCalendar: false,
      durationInDays: 1,
      tags: [],
      saving: false,
      displayOnCalendar: false,
      file: undefined,
    }
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    alertProp: {
      type: Object,
      required: false,
    },
  },
  watch: {
    alertProp: function (val) {
      if (val) {
        this.title = val.title
        this.content = val.content
        this.startDate = val.startDate
        this.durationInDays = val.durationInDays
        this.tags = this.tagItems.filter((x) => val.tags.includes(x.value))
        this.startDisplayingOn = val.startDisplayingOn
        this.stopDisplayingOn = val.stopDisplayingOn
        this.displayOnCalendar = val.displayOnCalendar
      }
    },
  },

  methods: {
    submit: async function () {
      if (
        this.$v.title.$invalid ||
        this.$v.content.$invalid ||
        this.$v.durationInDays.$invalid
      ) {
        this.$v.$touch()
        return
      }

      this.saving = true
      try {
        const result = await fetch('/api/Alerts', {
          method: this.type === 'edit' ? 'PUT' : 'POST',
          body: JSON.stringify({
            id: this.alertProp && this.alertProp.id ? this.alertProp.id : 0,
            title: this.title,
            content: this.content,
            shortContent: '',
            startDate: new Date(this.startDate),
            stopDisplayingOn: new Date(this.stopDisplayingOn),
            startDisplayingOn: new Date(this.startDisplayingOn),
            durationInDays: this.durationInDays,
            displayOnCalendar: this.displayOnCalendar,
            imageUrl: '',
            tags: this.tags.map((x) => x.value),
          } as IAlert),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        })
        if (!result.ok) {
          this.errors = await result.json()
        } else {
          const createdAlert = await result.json()

          if (this.file) {
            const uploadImageUrl = createdAlert.uploadImageUrl

            await fetch(uploadImageUrl, {
              method: 'PUT',
              body: this.file,
              headers: {
                'Content-Type': 'image/png',
                'x-ms-blob-type': 'BlockBlob',
              },
            })
          }

          this.close(createdAlert)
        }
      } finally {
        this.saving = false
      }
    },
    onFilePicked: function (file: File) {
      this.file = file
    },

    close(data: IModel | undefined): void {
      this.$emit('close', data)
      this.resetData()
    },
    resetData() {
      const curDate = new Date()
      const curDateStr = curDate.toISOString().substring(0, 10)
      this.title = ''
      this.content = ''
      this.startDisplayingOn = curDateStr
      this.stopDisplayingOn = curDateStr
      this.startDate = curDateStr
      this.endDate = curDateStr
      this.addToCalendar = false
      this.durationInDays = 1
      this.imageData = ''
      this.imageWidth = 0
      this.imageHeight = 0
      this.tags = []
      this.saving = false
      this.errors = []
      this.displayOnCalendar = false
    },
    setDimensions(x, y) {
      this.imageWidth = x
      this.imageHeight = y
    },
  },
  computed: {
    tagItems(): { value: number; title: string }[] {
      return [
        { value: 1, title: 'News' },
        { value: 2, title: 'Underwriters' },
        { value: 3, title: 'Product Updates' },
        { value: 4, title: 'Company Updates' },
        { value: 5, title: 'Industry' },
        { value: 6, title: 'Compliance' },
      ]
    },
    titleErrors(): string[] {
      const errors: string[] = []

      if (this.$v.title.$error) errors.push('Title is required')
      return errors
    },
    contentErrors(): string[] {
      const errors: string[] = []

      if (this.$v.content.$error) errors.push('Content is required')
      return errors
    },
    durationInDaysErrors(): string[] {
      const errors: string[] = []

      if (this.$v.durationInDays.$error)
        errors.push('Duration in Days must be a positive, whole number.')
      return errors
    },
    startDateErrors(): string[] {
      return this.errors
        .filter((x) => x.propertyName === 'StartDate')
        .map((x) => x.errorMessage)
    },
  },
  components: { ImagePicker, CIcon, Modal, ModalBody, DatePicker, QuillEditor },
  name: 'AddAlertModal',
})
